<template>
  <div class="p-3 bg-white">
    <shared-edit-user-permission @updateUserPermissionSuccess="updateUserPermissionSuccess"></shared-edit-user-permission>

    <div class="text-center">
      <vs-button id="editUserPermissionButton" class="m-2" color="primary" type="filled" @click.prevent="updateUserPermission">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelUserPermission">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import SharedEditUserPermission from '@/views/Shared/User/Permission/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.User.Permission.Edit',
  components: {
    SharedEditUserPermission
  },
  mounted () {
    EventBus.$emit('loadUserPermission', this.$route.params.id)
  },
  methods: {
    async updateUserPermission () {
      EventBus.$emit('initUpdateUserPermission')
    },
    updateUserPermissionSuccess (response) {
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })

      this.$windowOpenerHelper.notifyOpener('reload_users_table')
      window.close()
    },
    cancelUserPermission () {
      this.$windowOpenerHelper.notifyOpener('reload_users_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
